export const BOLDEST_ENDPOINTS = {
  resources: '/resources-v1',
  legacyResources: '/resources',
  categories: '/categories',
  zones: '/zones',
  populations: '/populations',
} as const;
